// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_lQ9","cls2":"TranslationModal-cls2_asr TranslationModal-cls1_lQ9"};